import { Link } from 'react-router-dom'
import {ArrowUpRight} from 'lucide-react'

interface Props {
  eyebrow?: string
  title: string
  body?: string
  ctaLabel?: string
  ctaTo?: string
  ctaHref?: string
}

function PageCTA({
  eyebrow = 'Et maintenant',
  title,
  body,
  ctaLabel = 'Réserver un appel gratuit',
  ctaTo = '/contact',
  ctaHref,
}: Props) {
  const buttonClass =
    'group mt-12 inline-flex items-center gap-3 px-8 py-4 bg-[#9E3A5A] text-[#F6EFF4] text-[13px] tracking-[0.2em] uppercase hover:bg-[#7A2D46] transition-colors duration-500'

  return (
    <section className="px-6 md:px-10 py-28 md:py-40 border-t border-[#DCC9D2]">
      <div className="max-w-5xl mx-auto text-center">
        <div className="text-[11px] tracking-[0.3em] uppercase text-[#C0923F] mb-8">{eyebrow}</div>
        <h2 className="font-serif-display text-[28px] md:text-[44px] leading-[1.1] text-[#1F1B1D] whitespace-pre-line">
          {title}
        </h2>
        {body && (
          <p className="mt-8 max-w-2xl mx-auto font-serif-display italic text-[18px] md:text-[20px] text-[#3A3236] leading-[1.55] whitespace-pre-line">{body}</p>
        )}
        {ctaHref ? (
          <a href={ctaHref} target="_blank" rel="noreferrer" className={buttonClass}>
            {ctaLabel}
            <ArrowUpRight size={16} className="transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        ) : (
          <Link to={ctaTo} className={buttonClass}>
            {ctaLabel}
            <ArrowUpRight size={16} className="transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        )}
      </div>
    </section>
  )
}

export default PageCTA
